//Custom colors
export const offersBackgroundColor = "#f8f8f8"
export const offersBackgroundLight = "#f8f8f8"
export const offersBackgroundLightGrey = "#f8f8f8"
export const offersWhiteColor = "#fff"
export const offersLightGrayColor = "#c8ccd4"
export const offersDividerColor = "#c8ccd4"
export const offersTextGrayColor = "#6e798e"
export const offersGrayColor = "#6e798e"
export const offersGreyMediumColor = "#6e798e"
export const offersGreyDarknessColor = "#6e798e"
export const offersGreyTextColor = "#6e798e"
export const offersBlackWopacityColor = "rgba(0, 0, 0, 0.2)"
export const offersGreenColor = "#1abc9c"
export const offersCalloutSuccessColor = "#b7ebe1"
export const offersCalloutSuccessTextColor = "#43894e"
export const offersCalloutSuccessBackgroundTextColor = "#b7ebe1"
export const offersLightGreenColor = "#1abc9c"
export const offersLightBlueColor = "#2d8abd"
export const offersLightBlueNewColor = "#2962ff"
export const offersLighterBlueColor = "#f8f8f8"
export const offersDarkBlueColor = "#22688e"
export const offersBlueColor = "#2d8abd"
export const offersTextBlueColor = "#2d8abd"
export const offersOrangeColor = "#f5a623"
export const offersLightOrangeColor = "#fa755a"
export const offersYellowLightColor = "#fff0c6"
export const offersYellowColor = "#fabf2c"
export const offersYellowFontColor = "#bb9433"
export const offersRosyColor = "#f23c5a"
export const offersLightRedColor = "#f2dede"
export const offersRedColor = "#e40e31"
export const offersCalloutDangerColor = "#e40e31"
export const offersCalloutDangerTextColor = "#f2dede"
export const offersPageBaseColor = "#f8f8f8"
export const offersBlackColor = "#6e798e"

export const offersDashedDivisor = "#dcdfe6"

export const offersTabSelectorBg = "#f8f8f8"

export const offersPlaceholderGreyColor = "#c8ccd4"

export const offersSaleDetailsColor = "#dcdfe6"
export const offersRankingTableColor = "#f8f8f8"

export const offersRedColorResale = "#f23c5a"

export const offersVenderMilhasBlueColor = "#dcdfe6"
export const offersVenderMilhasGoldColor = "#c5b59a"
export const offersVenderMilhasDiamondColor = "#223254"
export const offersVenderMilhasShadowColor = "#6e798e"
export const offersVenderMilhasSilverColor = "#6e798e"
export const offersVenderMilhasSpanColor = "#6e798e"

// Shadows
export const offersCardShadows = "4px 4px 10px -1px rgba(0, 0, 0, 0.1), 4px -4px 10px -1px rgba(0, 0, 0, 0.1)"
export const offersSmallCardShadows = "-4px 4px 17px -2px rgba(0, 0, 0, 0.1), 1px 2px 10px -1px rgba(0, 0, 0, 0.1)"

// Align
export const offersDefaultPadding = "16px"
export const offersDefaultMargin = "12px"

// Font
export const offersBigFont = "18px"
export const offersLargeFont = "16px"
export const offersNormalFont = "14px"
export const offersSmallFont = "12px"

// Breakpoints variable
export const screenXs = "0"
export const screenSm = "576px"
export const screenMd = "768px"
export const screenLg = "992px"
export const screenXl = "1200px"

//Breakpoints max variable
export const screenXsMax = `${screenSm} - 1px`
export const screenSmMax = `${screenMd} - 1px`
export const screenMdMax = `${screenLg} - 1px`
export const screenLgMax = `${screenXl} - 1px`